export class PurchaseOrderDetailModel {
    purchaseOrderDetailId: number = 0;
    purchaseOrderId: number = 0;
    articleId: number = 0;
    quantity: number = 0;
    ajustedQuantity: number = 0;
    unitValue: number = 0;
    ajustedUnitValue: number = 0;
    discountRate: number = 0;
    ajustedDiscountRate: number = 0;
    ivaRate: number = 0;
    ajustedIvaRate: number = 0;
    internalOrderDetailId: number | null = null;
    createDate: string = "";
    userNameCreate: string = "";
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}